import { Messages } from 'primereact/messages';
import * as React from 'react';
import { Fragment, useEffect, useRef, useState } from 'react';
import * as emptyImage from '../../../images/empty-image.svg';
import { FileInput, ImageUploaderWrap, MainImage, RemoveImage } from './styles';
var ImageControl = function (_a) {
    var onChange = _a.onChange, value = _a.value, noClose = _a.noClose;
    console.log('noClose', noClose);
    // Refference to the input file
    var imageInput = useRef(null);
    var maxSize = 2 * 1024 * 1024; // 2 MB
    var acceptedImages = 'image/jpg,image/jpeg,image/svg+xml,image/png';
    var messages = null;
    var _b = useState(emptyImage), image = _b[0], setImage = _b[1];
    // updating the value
    useEffect(function () {
        if (value && typeof value === 'string') { // the value is url of the image
            setImage(value);
        }
        else if (value) { // the value is a file
            readFile(value);
        }
    }, [value]);
    var changed = function (e) {
        // @ts-ignore
        var files = e.target.files;
        // More than one files selected
        if (files.length > 1) {
            return;
        }
        // Max size error
        if (files[0] && files[0].size > maxSize) {
            messages.show({ severity: 'error', detail: 'Размерът на изображението трябва да бъде до 2 MB', life: 5000 });
            return;
        }
        // wrong file format check
        if (files[0] && !acceptedImages.includes(files[0].type)) {
            messages.show({ severity: 'error', detail: 'Форматът не се поддържа', life: 5000 });
            return;
        }
        readFile(files[0]);
    };
    var readFile = function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            var result = reader.result;
            if (result === null) {
                return;
            }
            // custom event that will match the event.target.value structure
            var customEvent = {
                target: {
                    value: file
                }
            };
            onChange(customEvent);
            return setImage(result);
        };
    };
    var handleClick = function () {
        // Triggers the dialog for chosing a file 
        imageInput.current.click();
    };
    var removeImage = function () {
        var customEvent = {
            target: {
                value: null
            }
        };
        onChange(customEvent); // sending null to the form
        setImage(emptyImage);
    };
    return (React.createElement(Fragment, null,
        React.createElement(Messages, { ref: function (el) { messages = el; } }),
        React.createElement(ImageUploaderWrap, null,
            image !== emptyImage && !noClose ? React.createElement(RemoveImage, { onClick: removeImage },
                React.createElement("i", { className: "fa fa-times" })) : null,
            React.createElement(MainImage, { onClick: handleClick, src: image }),
            React.createElement(FileInput, { type: "file", onChange: changed, ref: imageInput, accept: acceptedImages }))));
};
export default ImageControl;



//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ImageControl/ImageControl.tsx
// module id = 276
// module chunks = 0